/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 /*
 * ------------------------------------------------------------------------------------------------------------
 * Product Page: Active ingredients modal (desktop)
 * ------------------------------------------------------------------------------------------------------------
*/
  window.openModal = function(event) {
    event.preventDefault();
    document.getElementById('ingredientModal').style.display = 'flex';
  };
  
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.close-button')?.addEventListener('click', function () {
    document.getElementById('ingredientModal').style.display = 'none';
  });
});

  window.onclick = function(event) {
    const modal = document.getElementById('ingredientModal');
    if (event.target === modal) {
      modal.style.display = "none";
    }
  };

/*
 * ------------------------------------------------------------------------------------------------------------
 * Product Page: Active ingredients carousel (mobile)
 * ------------------------------------------------------------------------------------------------------------
*/
  const track = document.querySelector('.carousel-track');
  const carouselContainer = document.querySelector('.carousel-container');
  const caption = document.querySelector('.carousel-caption');
  const originalSlides = Array.from(document.querySelectorAll('.carousel-slide'));
  const visibleCount = 3;
  let current = visibleCount + 1;

  originalSlides.slice(-visibleCount).forEach(slide => {
    const clone = slide.cloneNode(true);
    clone.classList.add('clone');
    track.prepend(clone);
  });

  originalSlides.slice(0, visibleCount).forEach(slide => {
    const clone = slide.cloneNode(true);
    clone.classList.add('clone');
    track.appendChild(clone);
  });

  const allSlides = Array.from(document.querySelectorAll('.carousel-slide'));

  function decodeHTMLEntities(str) {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  /**Developer's note: for this modal, I intentionally separate openModalMobile() event for mobile instead of using the 
   * openModal() of desktop due to some inconsistencies. 
  */

  function openModalMobile(event) {
    event.preventDefault();
    document.getElementById('ingredientModalMobile').style.display = 'flex';
  }
  
  function closeModal() {
    document.getElementById('ingredientModalMobile').style.display = 'none';
  }
  
  window.onclick = function(event) {
    const modal = document.getElementById('ingredientModalMobile');
    if (event.target === modal) {
      modal.style.display = "none";
    }
  }
  function updateSlides(animate = true) {
    allSlides.forEach(slide => slide.classList.remove('active'));

    const activeIndex = current % allSlides.length;
    const activeSlide = allSlides[activeIndex];
    activeSlide.classList.add('active');

    const slideWidth = activeSlide.offsetWidth + 10;
    const offset = (slideWidth * current) - ((carouselContainer.offsetWidth - slideWidth) / 2);

    track.style.transition = animate ? 'transform 0.5s ease' : 'none';
    track.style.transform = `translateX(-${offset}px)`;

    if (caption && activeSlide) {
      caption.innerHTML = decodeHTMLEntities(activeSlide.dataset.description || '');
    }
  }

  function shiftSlide(direction) {
    current += direction;
    updateSlides();

    track.addEventListener('transitionend', () => {
      if (current >= allSlides.length - visibleCount) {
        current = visibleCount;
        updateSlides(false);
      } else if (current < visibleCount) {
        current = allSlides.length - visibleCount * 2;
        updateSlides(false);
      }
    }, { once: true });
  }

  let startX = 0;
  let isDragging = false;

  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  track.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
  });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    const endX = e.changedTouches[0].clientX;
    const diffX = endX - startX;

    if (diffX > 30) shiftSlide(-1);
    else if (diffX < -30) shiftSlide(1);

    isDragging = false;
  });

  window.addEventListener('resize', () => updateSlides(false));
  updateSlides(false);